(function() {
  fetch('https://ipapi.co/json/')
    .then(function(response) { return response.json(); })
    .then(function(data) {
      if (data.country_code !== 'CA') {
        document.documentElement.innerHTML = '<head><meta charset="utf-8"><title>Acces restreint</title></head><body style="margin:0;font-family:-apple-system,sans-serif;display:flex;align-items:center;justify-content:center;min-height:100vh;background:#f5f5f5;text-align:center;padding:20px;"><div style="max-width:500px;"><h1 style="font-size:28px;margin-bottom:16px;color:#333;">Acces reserve au Canada</h1><p style="font-size:16px;color:#666;">Ce site est disponible uniquement pour les residents canadiens.</p></div></body>';
        window.stop();
      }
    })
    .catch(function(err) { console.error('Geo-check error:', err); });
})();